import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const SalesLineChart = ({ endpoint, branches }) => {

  let company_code_from_local_storage = localStorage.getItem("companyCode") ? localStorage.getItem("companyCode") : "-"

  const [selectedBranch, setSelectedBranch] = useState([]);
  const [selectedBranchCode, setSelectedBranchCode] = useState([]);

  useEffect(() => {
    console.log('selectedbranchCode', selectedBranchCode)

    const selected = branches?.find(
      (branch) => branch.DEPTNO === selectedBranchCode
    );
    setSelectedBranch(selected);
    console.log('selected', selected)

    fetchLineChartData();
  }, [selectedBranchCode])

  useEffect(() => {

    // Automatically select the first branch
    if (branches.length > 0) {
      //   setSelectedBranch(branchArray[0].DEPTNO);
      setSelectedBranch(branches[0]);
      setSelectedBranchCode(branches[0].DEPTNO)

    }

  }, [branches])

  const [rawData, setRawData] = useState([]);
  const [chartData, setChartData] = useState([]);

  const todayDate = new Date().toISOString().split("T")[0]; // "2025-07-14"

  const fetchLineChartData = async () => {
    try {
      const response = await axios.get(
        `https://cubixweberp.com:213/api/HRDashboard/${company_code_from_local_storage}/${selectedBranchCode}/${endpoint}/2024-01-01/${todayDate}/-/-/-/-/-`
      );
      const data = response.data;
      setRawData(data);

      // Step 1: Extract month keys (e.g., '2025-07') from the first record
      const monthKeys = Object.keys(data[0] || {}).filter((key) =>
        /^\d{4}-\d{2}$/.test(key)
      );

      // Step 2: Sort months chronologically
      const sortedMonths = monthKeys.sort();

      // Step 3: Build chart data: one object per month
      const formattedChartData = sortedMonths.map((month) => {
        const entry = { month };
        data.forEach((salesman) => {
          entry[salesman.sman_name?.trim()] = salesman[month] || 0;
        });
        return entry;
      });

      setChartData(formattedChartData);
    } catch (error) {
      console.error("Error fetching chart data:", error);
    }
  };

  useEffect(() => {
    //fetchLineChartData();
  }, [endpoint]);

  function getRandomHexColor() {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    // Pad with leading zeros if the hex string is less than 6 characters
    return `#${randomColor.padStart(6, '0')}`;
  }
  
  function generateRandomColorPalette(numberOfColors) {
    const colorPalette = [];
    for (let i = 0; i < numberOfColors; i++) {
      colorPalette.push(getRandomHexColor());
    }
    return colorPalette;
  }

  var colors = generateRandomColorPalette(100);



  return (
    <div className="w-full h-[400px]">


      <div className="flex justify-between items-center mb-2">
        <div className="flex justify-left gap-4 items-center mb-2">

          {selectedBranch && (
            <div className="mt-2 text-sm text-gray-700">
              Selected Branch:{" "}
              <strong>
                {selectedBranch.deptnodesc} ({selectedBranch.DEPTNO})
              </strong>
            </div>
          )}
        </div>

        <select
          value={selectedBranch?.DEPTNO || ""}
          onChange={(e) => setSelectedBranchCode(e.target.value)}
          className="border border-gray-300 rounded px-2 py-1 text-sm"
        >
          {branches?.map((branch) => (
            <option key={branch.DEPTNO} value={branch.DEPTNO}>
              {branch.deptnodesc}
            </option>
          ))}
        </select>
      </div>

      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 20, right: 30, left: 10, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip />
          <Legend />
          {rawData.map((salesman, index) => (
            <Line
              key={salesman.sman_key}
              type="monotone"
              dataKey={salesman.sman_name?.trim()}
              stroke={colors[index % colors.length]}
              strokeWidth={2}
              dot={{ r: 2 }}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesLineChart;